import { Tag as AriaChip, TagProps as AriaChipProps, Button } from 'react-aria-components';
import { useContext, type ReactNode } from 'react';

import { css } from '@allenai/varnish-panda-runtime/css';

import { cx } from '@/utils/cx';

import { Close } from '@/components/icons';

import focusRing from '@/components/shared/focusRing.styles';

import { chipRecipe, type ChipRecipeProps } from './chip.styles';
import { ChipGroupContext } from '@/components/chip/ChipGroup';

export type ChipItem = {
    id: string;
    text?: string;
    icon?: ReactNode;
    href?: string;
    isDisabled?: boolean;
    className?: string;
    removeButtonClassName?: string;
    onClick: AriaChipProps['onClick']; // TODO: Fix props https://github.com/allenai/varnish/issues/1200
};

type ChipProps = AriaChipProps & ChipItem & ChipRecipeProps;

const Chip = ({ icon, text, className, removeButtonClassName, ...rest }: ChipProps) => {
    // Get the group props first, we will merge when rest and split the variantProps and localProps
    const groupProps = useContext(ChipGroupContext);

    const [variantProps, localProps] = chipRecipe.splitVariantProps({
        ...groupProps,
        ...rest,
        hasIcon: !!icon,
    });
    const recipeClassNames = chipRecipe(variantProps);
    return (
        <AriaChip {...localProps} className={cx(css(focusRing), recipeClassNames.root, className)}>
            {(renderProps) => (
                <>
                    {icon}
                    <span className={recipeClassNames.text}>{text}</span>
                    {renderProps.allowsRemoving && (
                        <Button
                            slot="remove"
                            className={cx(recipeClassNames.removeButton, removeButtonClassName)}>
                            <Close size="medium" />
                        </Button>
                    )}
                </>
            )}
        </AriaChip>
    );
};

export { Chip };
export type { ChipProps };
